import { trackLead } from './leads';

export const fireMalLeadTracking = function(malLeads, opts={}) {
  const leadGuids = {},
        malListings = opts.malListings,
        guidsForAdobeDtm = [];
  if (malLeads instanceof Array) {
    //create a hashmap of all checked mal properties
    malLeads.forEach(function(lead) {
      leadGuids[lead.listing_id] = lead.id;
      guidsForAdobeDtm.push(lead.id);
    });
    //compare the above map with all potential malListings and submit the ones that were selected.
    if (malListings) {trackMalLeads(malListings, leadGuids, opts )}
  }
  updateDtmObject(guidsForAdobeDtm);
};

const trackMalLeads = (malListings, leadGuids, opts) => {
  malListings.forEach(function(property, index){
    if (property.listing_id && leadGuids[property.listing_id.toString()]) {
      const trackingOptions = {
                                leadGuid: leadGuids[property.listing_id.toString()],
                                is_mal: true,
                                placementData: `pos_${index}`,
                                leadValue: opts.leadValue,
                                initialLeadValue: opts.initialLeadValue,
                                property_type: property.status,
                                property_status: property.status,
                                type: property.property_type,
                              };
      trackLead(Object.assign({}, property, trackingOptions ));
    }
  })
}

const updateDtmObject = (guidsForAdobeDtm) => {
  MOVE.Helper.updateOmnitureLeadJson({ leadGuid: guidsForAdobeDtm, malCt: guidsForAdobeDtm.length });
}



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/mal_leads.js